import { useSnackbar } from "notistack";
import { Box, Grid } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
import PropTypes from "prop-types";

import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import FormSelect from "../../../components/Form/controls/FormSelect.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";

const rppOptions = [
  { key: "5", label: "5" },
  { key: "10", label: "10" },
  { key: "20", label: "20" },
  { key: "25", label: "25" },
  { key: "50", label: "50" },
  { key: "100", label: "100" },
];

const DisplaySettingsSection = ({ userData, setUser }) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (data, formMethods) => {
    let success = false;
    await backendPatch("data/user/account", {
      toSend: data,
      label: "Anzeigeeinstellungen",
      enqueueSnackbar,
      setError: formMethods.setError,
      successMessage: "Einstellungen erfolgreich gespeichert.",
      onSuccess: (response) => {
        if (response.user) {
          setUser(response.user);
          success = true;
        }
      },
    });
    return success;
  };

  return (
    <Box>
      <Form
        onSubmit={onSubmit}
        defaultValues={{
          rpp: String(userData?.settings?.rpp ?? "25"),
        }}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormSelect
              name="rpp"
              label="Zeilen pro Seite"
              options={rppOptions}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <SubmitButton>Speichern</SubmitButton>
          </Grid>
        </Grid>
      </Form>
    </Box>
  );
};

DisplaySettingsSection.propTypes = {
  userData: PropTypes.shape({
    theme: PropTypes.string,
    language: PropTypes.string,
    settings: PropTypes.shape({
      rpp: PropTypes.number,
    }),
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default DisplaySettingsSection;
